var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import { observer } from 'mobx-react';
import styles from './settings.module.scss';
let Settings = class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.onCheckbox = this.onCheckbox.bind(this);
    }
    onCheckbox(refName) {
        return (event) => {
            if (typeof this.props.store[refName] === 'boolean') {
                this.props.store[refName] = event.target.checked;
            }
        };
    }
    render() {
        const { store } = this.props;
        return (React.createElement("div", { className: styles.root },
            React.createElement("h2", { className: styles.title }, "Settings"),
            React.createElement("div", { className: styles.settings },
                React.createElement("div", { className: styles.setting },
                    React.createElement("label", null, "Night mode"),
                    React.createElement("input", { type: "checkbox", checked: store.nightMode, onChange: this.onCheckbox('nightMode') })),
                React.createElement("div", { className: styles.setting },
                    React.createElement("label", null, "Clear all data (this cannot be undone)"),
                    React.createElement("button", { onClick: store.clear }, "Clear")),
                React.createElement("div", { className: styles.setting },
                    React.createElement("label", null, "GreyCat Lang Linter Strict-Mode"),
                    React.createElement("input", { type: "checkbox", checked: store.strictMode, onChange: this.onCheckbox('strictMode') }))),
            React.createElement("div", { className: styles.close },
                React.createElement("button", { onClick: store.close }, "Close"))));
    }
};
Settings = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Settings);
export default Settings;
